@if (item) { @if (item.type === 'EXHIBITOR') {
<bau365-exhibitor-card
  [item]="item"
  [fairId]="item.fair_id"
  [insightsId]="insightsId"
  [pageContext]="pageContext"
  [size]="size"
  [markAsNew]="markAsNew">
</bau365-exhibitor-card>
} @if (item.type === 'PRODUCT') {
<bau365-product-card
  [item]="item"
  [exhibitor]="item.exhibitor"
  [fairId]="item.fair_id"
  [pageContext]="pageContext"
  [size]="size"
  [markAsNew]="markAsNew">
</bau365-product-card>
} @if (item.type === 'EVENT') {
<bau365-event-card
  [item]="item"
  [exhibitor]="item.exhibitor"
  [fairId]="item.fair_id"
  [pageContext]="pageContext"
  [size]="size"
  [markAsNew]="markAsNew">
</bau365-event-card>
} @if (item.type === 'POST') {
<bau365-post-card
  [item]="item"
  [exhibitor]="item.exhibitor"
  [fairId]="item.fair_id"
  [pageContext]="pageContext"
  [size]="size"
  [markAsNew]="markAsNew">
</bau365-post-card>
} }
